import { fetchPost } from "./fetchcalls"

export async function SendEmail(formData) {
	return await fetchPost(`/api/email/recieve`, formData)
}